import CheckBoxSmall from './CheckBoxSmall';

export default CheckBoxSmall;
